import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { CadastroProdutoService } from '../services/cadastro-produto.service';

@Injectable({
  providedIn: 'root'
})
export class ProdutoProjetoResolver implements Resolve<boolean> {

  constructor(private service: CadastroProdutoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}